export default __webpack_public_path__ + "static/media/bg4.01ad1068.jpg";